
import _ from 'lodash'
import {getQuickWords} from "@/api/custom.js"
const QuickWords = {
    state: {
        quickwordList: [],
        inputQuickWord:'',
        // 分页相关状态
        currentPage: 1,
        pageSize: 10,
        total: 0,
        loading: false
    },
    mutations: {
        SET_INPUT_QUICK_WORD: (state, payload) => {
            state.inputQuickWord = payload
        },
        SET_QUICK_WORD_LIST: (state, payload) => {
            state.quickwordList = payload
        },
        SET_QUICK_WORD_PAGINATION: (state, { currentPage, pageSize, total }) => {
            state.currentPage = currentPage
            state.pageSize = pageSize
            state.total = total
        },
        SET_QUICK_WORD_LOADING: (state, loading) => {
            state.loading = loading
        }
    },
    actions: {
        // 获取快捷用语
        getQuickWordsList: async ({ commit, state }, { pageNum = 1, pageSize = 10 } = {}) => {
            try {
                commit('SET_QUICK_WORD_LOADING', true)
                let obj = {
                    pageNum: pageNum,
                    pageSize: pageSize
                }
                const response = await getQuickWords(obj)
                //console.log("%c Line:27 🧀拿到快捷语数据 response", "color:#e41a6a", response);
                
                if(response && response.rows){
                    commit('SET_QUICK_WORD_LIST', response.rows)
                    commit('SET_QUICK_WORD_PAGINATION', {
                        currentPage: pageNum,
                        pageSize: pageSize,
                        total: response.total || 0
                    })
                } else {
                    commit('SET_QUICK_WORD_LIST', [])
                    commit('SET_QUICK_WORD_PAGINATION', {
                        currentPage: 1,
                        pageSize: pageSize,
                        total: 0
                    })
                }
            } catch (error) {
                console.error('获取快捷用语失败:', error)
                commit('SET_QUICK_WORD_LIST', [])
                commit('SET_QUICK_WORD_PAGINATION', {
                    currentPage: 1,
                    pageSize: pageSize,
                    total: 0
                })
            } finally {
                commit('SET_QUICK_WORD_LOADING', false)
            }
        }
    }
}

export default QuickWords
